import { useNavigate, useParams } from "react-router-dom";

import { EditIcon } from "@chakra-ui/icons";
import { Box, Button, Text } from "@chakra-ui/react";

interface Props {
  fullName: string;
  address: string;
  segment: string;
  id?: number;
}

export const ProviderPreview = ({
  id,
  fullName,
  address,
  segment
}: Props) => {
  const navigator = useNavigate();
  const { id: condominiumId } = useParams();

  const handleNavigateToProviderDetails = () => {
    if (!id) return;
    navigator(`/dashboard/condominiums/condominium/${condominiumId}/providers/provider/${id}`);
  };

  const handleNavigateToProviderEditForm = () => {
    if (!id) return;
    navigator(
      `/dashboard/condominiums/condominium/${condominiumId}/providers/provider/${id}/edit`
    );
  };

  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      bg="gray.50"
      maxHeight="min"
      minHeight={120}
      minWidth="120px"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
      <Box
        onClick={handleNavigateToProviderDetails}
        style={{
          cursor: "pointer",
        }}
        p="6"
        display="flex"
        justifyContent="space-between"
        flexDirection="column"
      >
        <Text
          fontWeight="semibold"
          as="h4"
          lineHeight="tight"
          isTruncated
        >
          {fullName}
        </Text>
        <Text>{address}</Text>
        <Text>{segment}</Text>
      </Box>
      {id && (
        <Button
          variant={"ghost"}
          onClick={handleNavigateToProviderEditForm}
          display="flex"
          mt="2"
          alignItems="center"
        >
          <EditIcon
            boxSize={6}
            bg="white"
            color="green"
            borderColor="gray.200"
          />
        </Button>
      )}
    </Box>
  );
};
